import React from 'react';
import { ActionPopup, BodyTemplate, CardWithTabs, ResponsiveButton, Icon, ManagerPermissionContent, EntireLoader, checkPermissionForOnClick } from 'renderer/components';
import { MANAGER_PERMISSION_ACTIONS, MANAGER_PERMISSION_KEYS, MANAGER_PERMISSION_PRIORITY } from 'renderer/models';
import { RegisterGoals, SalesGoalTab } from './components';
import { IncentiveTab, RegisterIncentive } from './components/IncentiveTab';
import { ManagerQuery, StoreQuery } from 'renderer/queries';
import { IncentiveDetailTab } from './components/IncentiveDetailTab';
import { isEmpty, useWindowSize } from 'renderer/utils';
import dayjs from 'dayjs';
var EmployeeSales = function (props) {
    var store = StoreQuery.getMyStoreInCache();
    var tabs = [
        { tab: '직원별 결산', key: 'incentive' },
        { tab: '직원별 상세결산', key: 'incentiveDetail' },
        { tab: '목표매출', key: 'goals' }
    ];
    var loginManager = ManagerQuery.getLoginManagerInCache();
    var workingManagers = ManagerQuery.getWorkingManagersInCache();
    var _a = React.useState(), incentiveDrawer = _a[0], setIncentiveDrawer = _a[1];
    var _b = React.useState(), goalDrawer = _b[0], setGoalDrawer = _b[1];
    var isPC = useWindowSize().isPC;
    var handleOpen = function (data) {
        if (data === null || data === void 0 ? void 0 : data.month) {
            setGoalDrawer(data);
        }
        else {
            if (checkPermissionForOnClick(salesIncentivePermission, '직원 인센티브 설정 권한이 없습니다.')) {
                setIncentiveDrawer(true);
            }
        }
    };
    var salesGoalPermission = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission({
        key: MANAGER_PERMISSION_KEYS.SALES_GOALS_SETTING,
        action: MANAGER_PERMISSION_ACTIONS.UPDATE,
        priority: MANAGER_PERMISSION_PRIORITY.ALL
    });
    var salesIncentivePermission = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission({
        key: MANAGER_PERMISSION_KEYS.SALES_INCENTIVE,
        action: MANAGER_PERMISSION_ACTIONS.UPDATE,
        priority: MANAGER_PERMISSION_PRIORITY.ALL
    });
    var isAllSalesGoal = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission({
        key: MANAGER_PERMISSION_KEYS.SALES_GOALS,
        action: MANAGER_PERMISSION_ACTIONS.READ,
        priority: MANAGER_PERMISSION_PRIORITY.ALL
    });
    var isAllIncentive = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission({
        key: MANAGER_PERMISSION_KEYS.SALES_REPORT,
        action: MANAGER_PERMISSION_ACTIONS.READ,
        priority: MANAGER_PERMISSION_PRIORITY.ALL
    });
    var children = {
        goals: workingManagers && loginManager ? (React.createElement(ManagerPermissionContent, { manager: loginManager, permission: {
                key: MANAGER_PERMISSION_KEYS.SALES_GOALS,
                action: MANAGER_PERMISSION_ACTIONS.READ,
                priority: MANAGER_PERMISSION_PRIORITY.MINE
            }, descriptions: ['목표매출 조회 권한이 없습니다.'], children: React.createElement(SalesGoalTab, { hasUpdatePermission: salesGoalPermission, isAll: isAllSalesGoal, store: store, loginManager: loginManager, workingManagers: workingManagers, isPC: isPC, onClickDrawerOpen: handleOpen }) })) : (React.createElement("div", null)),
        incentive: workingManagers ? (React.createElement(ManagerPermissionContent, { manager: loginManager, permission: {
                key: MANAGER_PERMISSION_KEYS.SALES_REPORT,
                action: MANAGER_PERMISSION_ACTIONS.READ,
                priority: MANAGER_PERMISSION_PRIORITY.MINE
            }, descriptions: ['결산조회 권한이 없습니다.'], children: React.createElement(IncentiveTab, { isPC: isPC, store: store, loginManager: loginManager, isAll: isAllIncentive, workingManagers: workingManagers, onClickDrawerOpen: handleOpen }) })) : (React.createElement("div", null)),
        incentiveDetail: workingManagers ? (React.createElement(ManagerPermissionContent, { manager: loginManager, descriptions: ['결산조회 권한이 없습니다. '], permission: {
                key: MANAGER_PERMISSION_KEYS.SALES_REPORT,
                action: MANAGER_PERMISSION_ACTIONS.READ,
                priority: MANAGER_PERMISSION_PRIORITY.MINE
            }, children: React.createElement(IncentiveDetailTab, { isPC: isPC, isAll: isAllIncentive, store: store, workingManagers: workingManagers, loginManager: loginManager, onClickDrawerOpen: handleOpen }) })) : (React.createElement("div", null))
    };
    var hasManager = !isEmpty(workingManagers);
    return store ? (React.createElement(BodyTemplate, { title: "\uC9C1\uC6D0\uBCC4 \uACB0\uC0B0", extra: !isPC && (React.createElement(ActionPopup, { trigger: React.createElement(ResponsiveButton, { icon: React.createElement(Icon, { name: "settings", strokeWidth: 2, size: 18 }), children: "\uC124\uC815" }), actions: [
                {
                    label: '직원별 목표매출 설정',
                    onClick: function () {
                        if (checkPermissionForOnClick(salesGoalPermission, '목표매출 설정 권한이 없습니다.')) {
                            setGoalDrawer({ month: dayjs() });
                        }
                    }
                },
                {
                    label: '직원별 인센티브 설정',
                    onClick: function () {
                        handleOpen();
                    }
                }
            ] })), content: React.createElement(React.Fragment, null,
            hasManager && React.createElement(CardWithTabs, { tabList: tabs, defaultActiveTabKey: "incentive", children: children }),
            hasManager && (React.createElement(RegisterIncentive, { managers: workingManagers, visible: incentiveDrawer, store: store, onClose: function () {
                    setIncentiveDrawer(undefined);
                } })),
            hasManager && (React.createElement(RegisterGoals, { managers: workingManagers, drawer: goalDrawer, onClose: function () { return setGoalDrawer(undefined); }, store: store }))) })) : (React.createElement(EntireLoader, { open: true }));
};
export default EmployeeSales;
